import { Box, Typography } from '@mui/material';
import { NavBar } from '../../common/NavBar/NavBar'
import { useState, SyntheticEvent } from 'react';
import { ReactElement } from 'react';
import { PrizeLocalization } from './PrizeLocalization';
import { AddLanguageTabs } from '../../components/modals/AddLanguageTabs';
import { getIn } from 'formik';
import { languageCodes } from '../../constants/lists';
import { updateImgUrls } from '../../utils/prizeUtils';

interface PrizeTabProps {
    formik: any,
    tabs: string[],
    backstepDone?: boolean,
    isEdit?: boolean,
    defaultLang: string,
    setTabLabels: React.Dispatch<React.SetStateAction<string[]>>
}
function PrizeTabSwitch({ formik, tabs, backstepDone, isEdit, defaultLang, setTabLabels }: PrizeTabProps) {
    const [open, setOpen] = useState(false);
    const [customIndex, setCustomIndex] = useState<number | null>(1);
    const [languageIndex, setLanguageIndex] = useState<number>(0);
    const handleModalOpen = (event: SyntheticEvent, index: number) => {
        if (index === 0) {
            setOpen(true)
        }
    }

    const handleTabDeleteFromFormikState = (language?: string): void => {
        const stateValues: string[] = ['name', 'desc', 'short_desc', 'redeem_desc'];
        let languageCode = Object.keys(languageCodes).find(key => languageCodes[key] === language);
        let indexToDelete: number;
        stateValues.forEach((value)=> {
            formik.values[value].forEach((innerValue, index) => {
                if (innerValue.hasOwnProperty(languageCode)) {
                    indexToDelete = index;
                }
            })
        formik.values[value].splice(indexToDelete, 1);
        })
        const langUrls = formik.values.tempParams.img_url?.[languageCode] || []
        const usesDefaultImgs = formik.values.tempParams.langUsingDefaultImgs[languageCode]
        if (!usesDefaultImgs && langUrls.length !== 0) {
            const imgUrlsCopy = [...formik.values.img_url]
            for (const url of langUrls) {
                updateImgUrls(url, formik, imgUrlsCopy)
            }
        }
        if (formik.values.images_metadata && (languageCode in formik.values.images_metadata)) {
            formik.setFieldValue(`images_metadata[${languageCode}]`, undefined)
        }
        formik.setFieldValue(`tempParams.img_url[${languageCode}]`, undefined)
        formik.setFieldValue(`tempParams.langUsingDefaultImgs[${languageCode}]`, undefined)
    }

    const tabComponents: Array<ReactElement> = [];
    tabs.forEach((value: string, index: number) => {
        if (value.toLocaleLowerCase().includes('add')) {
            tabComponents.splice(0, 0, <AddLanguageTabs modalOpenState={open} tabs={tabs} country={getIn(formik.values, 'tempParams.country')} handleClose={setOpen} handleCustomIndex={setCustomIndex} setTabLabels={setTabLabels} languageFieldName={'prizeLanguage'}/>);
        } else {
            const code = Object.keys(languageCodes).find(key => languageCodes[key] === value) || 'en'
            tabComponents.splice(index , 0, <PrizeLocalization backstepDone={backstepDone} isEdit={isEdit} formik={formik} language={code} setLanguageIndex={setLanguageIndex} languageIndex={languageIndex} tabIndex={index} defaultLang={defaultLang} numberOfTabs={tabs.length}/>)
        }
    })
    return (
        <Box className='prize-box-main'>
            <Typography variant='h4' gutterBottom>Prize Localization</Typography>
            <Typography variant='body1' gutterBottom>Provide localized texts for every applicable language</Typography>
            <NavBar enableDirectionSelectArrows={true} deleteTabButtonCustomAction={handleTabDeleteFromFormikState}  enableTabRemove={true} tabLabels={tabs} customAction={handleModalOpen} components={tabComponents} navClass='nav-tabs' customTabIndex={customIndex} resetCustomIndex={setCustomIndex} />
        </Box>
    )
}

export { PrizeTabSwitch }
